export default function PortalLoginDivider({ theme = 'dark' }) {
  if (theme === 'light') {
    return (
      <div className="relative my-2">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-slate-200" />
        </div>
        <div className="relative flex justify-center">
          <span className="bg-white px-2 text-[11px] text-slate-500">or</span>
        </div>
      </div>
    );
  }

  return (
    <div className="relative my-2">
      <div className="absolute inset-0 flex items-center">
        <div className="w-full border-t border-white/10" />
      </div>
      <div className="relative flex justify-center">
        <span className="bg-black px-2 text-[11px] text-white">or</span>
      </div>
    </div>
  );
}
